import { validator } from "@/utils/validator";

export const contactTypeSchema = validator.object().shape({
  name: validator.string().trim().label("お問い合わせの種類").required().max(255),
  template: validator.string().trim().label("テンプレート").notRequired().nullable().optional(),
  email: validator.string().emptyToNull().email().max(60).label("お問い合わせの通知先メールアドレス").required(),
});
